import { DRAWER_TYPES } from '@/constants/drawer';
import { ROLES } from '@/constants/roles';

export const eventCreate = {
  path: '/event-create',
  name: 'ui-event-create',
  component: () => import('@/modules/UIDesign/Events/views/event-create/event-create.vue'),
  meta: {
    layout: 'ui-design',
    icon: '$ui-plus',
    title: 'Создание мероприятия',
    accessList: [ROLES.organization, ROLES.event_manager],
    button: true,
    buttonTitle: 'Создать мероприятие',
    children: [
      {
        text: 'Создать с нуля',
        to: '/event-create',
        icon: '$ui-document-plus',
      },
      {
        text: 'Выбрать из шаблонов',
        to: '/event-create-by-templates',
        icon: '$ui-duplicate',
      },
    ],
  },
};

export const eventCreateByTemplates = {
  path: '/event-create-by-templates',
  name: 'ui-event-create-by-templates',
  component: () => import('@/modules/UIDesign/Events/views/event-create/event-create-by-templates.vue'),
  meta: {
    layout: 'ui-design',
    title: 'Мероприятие из шаблона',
    accessList: [ROLES.organization, ROLES.event_manager],
  },
};

export default [
  eventCreate,
  eventCreateByTemplates,
  {
    path: '/event/view/:id/edit',
    name: 'ui-event-landing',
    component: () => import('@/modules/UIDesign/Events/views/event-landing.vue'),
    meta: {
      title: 'Страница мероприятия',
      layout: 'remaked',
      editor: true,
      hideFirstSubdrawer: true,
      subdrawer: DRAWER_TYPES.portal,
      subdrawerWidth: 380,
      accessList: [ROLES.organization, ROLES.event_manager],
    },
  },
  {
    path: '/event-dashboard/:id',
    name: 'ui-event-dashboard',
    component: () => import('@/modules/UIDesign/Events/views/event-dashboard/index.vue'),
    meta: {
      layout: 'ui-design',
      accessList: [ROLES.organization, ROLES.event_manager],
    },
    children: [
      {
        path: 'main',
        name: 'ui-event-dashboard-main',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-main.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Управление мероприятием',
          accessList: [ROLES.organization, ROLES.event_manager],
          subtitle: true,
        },
      },
      {
        path: 'main-settings',
        name: 'ui-event-dashboard-main-settings',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-main-settings.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Настройки мероприятия',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'settings',
        name: 'ui-event-dashboard-settings',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-event-settings.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Редактирование',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'program-data',
        name: 'ui-event-dashboard-program-data',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-program-data.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Заполнение данных',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'members',
        name: 'ui-event-dashboard-members',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-members.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Заявки и участники',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'main-organizers',
        name: 'ui-event-dashboard-main-organizers',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-main-organizers.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Соорганизаторы',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'templates',
        name: 'ui-event-dashboard-templates',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-template/dashboard-templates.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Требования к мероприятиям',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'organizers',
        name: 'ui-event-dashboard-organizers',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-organizers.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Управление соорганизаторами',
          subtitle: true,
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'template/:templateEventId',
        name: 'ui-event-dashboard-template-main',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-template/index.vue'),
        meta: {
          back: true,
          subtitle: true,
          layout: 'ui-design',
          title: 'Шаблон нижестоящего мероприятия',
          accessList: [ROLES.organization],
        },
        children: [
          {
            path: 'settings',
            name: 'ui-event-dashboard-template-settings',
            component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-template/template-settings.vue'),
            meta: {
              back: true,
              subtitle: true,
              layout: 'ui-design',
              title: 'Редактирование требований',
              accessList: [ROLES.organization],
            },
          },
          {
            path: 'tasks',
            redirect: (to) => ({
              name: 'ui-event-dashboard-templates',
              params: {
                id: to.params.id,
              },
            }),
          },
          {
            path: 'tasks/create',
            name: 'ui-event-dashboard-template-task-create',
            component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-template/create-template-task.vue'),
            meta: {
              back: true,
              subtitle: true,
              layout: 'ui-design',
              title: 'Добавление задания',
              accessList: [ROLES.organization],
            },
            props: (route) => ({
              taskType: route.query.type,
              taskFormat: route.query.format,
            }),
            beforeEnter: (to, from, next) => {
              if (!to.query.type || !to.query.format) {
                next({
                  name: 'ui-event-dashboard-templates',
                  params: {
                    id: to.params.id,
                  },
                });
                return;
              }

              next();
            },
          },
          {
            path: 'tasks/:taskId/edit',
            name: 'ui-event-dashboard-template-task-edit',
            component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-template/edit-template-task.vue'),
            props: (route) => ({
              taskId: Number(route.params.taskId),
            }),
            meta: {
              back: true,
              subtitle: true,
              layout: 'ui-design',
              title: 'Редактирование задания',
              accessList: [ROLES.organization],
            },
          },
        ],
      },
      {
        path: 'reports',
        name: 'ui-event-dashboard-reports',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-reports.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Отчёты',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'activity-statistics',
        name: 'ui-event-dashboard-activity-statistics',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-activity-statistics.vue'),
        meta: {
          title: 'Статистика активности',
          back: true,
          layout: 'ui-design',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'import-members',
        name: 'ui-event-dashboard-import-members',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-import-members.vue'),
        meta: {
          title: 'Импорт участников',
          back: true,
          layout: 'ui-design',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
    ],
  },
];
